import axios from 'axios';
import { serverUrl } from '../../components/Helpers/Config';
import { tokenAuthorize } from '../../components/Helpers/Common';

export const LINK_LOADED = 'LINK_LOADED';
export const LINK_CREATED = 'LINK_CREATED';
export const LINK_DELETED = 'LINK_DELETED';
export const LINK_PROCESS_LOADING = 'LINK_PROCESS_LOADING';
export const LINK_PROCESS_FAILED = 'LINK_PROCESS_FAILED';

export const generateLink = (profileID) => {
    return (dispatch, getState) => {
        // dispatch({ type: LINK_PROCESS_LOADING })

        return axios.post(
            serverUrl.GenerateLink, { "profile_id": profileID }
        ).then(resp => {
            if (resp.status === 200) {

                dispatch(getGeneratedLink(profileID))
                // dispatch({ type: LINK_CREATED })

            } else {
                dispatch({ type: LINK_PROCESS_FAILED })
            }

        }).catch((err) => {
            tokenAuthorize(err?.response?.status)
            dispatch({
                type: LINK_PROCESS_FAILED, errors: [err]
            })

        })
    }
}

export const getGeneratedLink = (profileID) => {
    return (dispatch, getState) => {
        dispatch({ type: LINK_PROCESS_LOADING })
        return axios.get(
            serverUrl.GenerateLink + '?profile_id=' + profileID
        ).then(resp => {
            if (resp.data.length !== 0) {
                let link = resp.data

                dispatch({
                    type: LINK_LOADED,
                    payload: { link }
                })
            }
            else {
                dispatch({
                    type: LINK_PROCESS_FAILED
                })
            }

        }).catch((err) => {
            tokenAuthorize(err?.response?.status)
            dispatch({
                type: LINK_PROCESS_FAILED, errors: [err]
            })
        })

    }
}

export const removeGeneratedLink = (profileID) => {
    return (dispatch) => {
        dispatch({ type: LINK_PROCESS_LOADING })

        return axios.delete(
            serverUrl.GenerateLink + '?profile_id=' + profileID
        ).then(resp => {

            if (resp.status === 200) {
                dispatch({ type: LINK_DELETED });
                // dispatch(getGeneratedLink());
            } else {
                dispatch({ type: LINK_PROCESS_FAILED })
            }
        }).catch((err) => {
            tokenAuthorize(err?.response?.status)
            dispatch({
                type: LINK_PROCESS_FAILED, errors: [err]
            })
            throw (err)
        })
    }
}




